export default __webpack_public_path__ + "static/nexo-edbe11dc5d0c0748e88db159ce51362f.png";